import { create } from 'zustand';

import { Spot30mTwapStore } from './spot30mTwap.types';

const useSpot30mTwapStore = create<Spot30mTwapStore>(set => ({
  selectedProductSpotTwap: null,
  setSelectedProductSpotTwap: value => set({ selectedProductSpotTwap: value }),
  twapVisible: false,
  showTwap: () => set({ twapVisible: true }),
  hideTwap: () => set({ twapVisible: false }),
}));

// Standalone actions for epics and other non-React contexts
const { setSelectedProductSpotTwap, showTwap, hideTwap } = useSpot30mTwapStore.getState();

export { useSpot30mTwapStore, setSelectedProductSpotTwap, showTwap, hideTwap };
